var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin_1_",
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.798,62.986h14.315V22.368H0.798V62.986z M48.434,21.087c-5.925,0-9.192,1.972-12.953,6.749v-5.469H21.189v40.619 H35.48V40.914c0-4.658,2.24-9.214,7.596-9.214s6.673,4.555,6.673,9.103v22.184H64v-23.09C64,23.854,54.361,21.087,48.434,21.087z  M7.982,2.013C3.572,2.013,0,5.222,0,9.183c0,3.958,3.572,7.162,7.982,7.162c4.406,0,7.978-3.205,7.978-7.162 C15.96,5.222,12.388,2.013,7.982,2.013z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.034c7675013af6ddabff5f438b620ddc.svg";
export { ForwardRef as ReactComponent };